import type { Schema } from '@dealdesk/api-schema';

export interface EmployerListParams {
  q?: string;
  sort?: string;
  page?: number;
  size?: number;
  bank?: string;
  listed?: boolean;
  /** With bank: category code / listing state in force today at that bank. */
  category?: string;
  state?: 'on_list' | 'not_on_list' | 'no_classification';
  status?: Schema<'EmployerStatus'>;
}

export const employerKeys = {
  all: ['employers'] as const,
  lists: () => [...employerKeys.all, 'list'] as const,
  list: (p: EmployerListParams) => [...employerKeys.lists(), p] as const,
  detail: (id: string) => [...employerKeys.all, 'detail', id] as const,
  duplicates: () => [...employerKeys.all, 'duplicates'] as const,
  enlistments: (p: { status?: Schema<'EnlistmentStatus'>[]; bank?: string }) => [...employerKeys.all, 'enlistments', p] as const,
  unresolved: () => [...employerKeys.all, 'unresolved'] as const,
  categories: (bankId: string) => ['employer-categories', bankId] as const,
};
